module.exports = __webpack_public_path__ + "static/assets/00f8447bd7dd3fbd1ca78e94ddeb4ea9.svg";